module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_features_03-a9521fc93ad51e131f15b2af71b4dcdd.png";